"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoPreview = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styles_1 = require("../../styles");
const layout_1 = require("../layout");
const CornerPad = (0, styles_1.styled)(layout_1.Box)(({ theme, rotation }) => ({
    position: 'absolute',
    width: '33px',
    height: '33px',
    borderTop: `1px solid ${theme.colors.grey30}`,
    borderLeft: `1px solid ${theme.colors.grey30}`,
    transform: `rotate(${rotation}deg)`,
}));
const LogoBox = (0, styles_1.styled)(layout_1.Flex)(({ height }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    height: height,
    width: '200px',
    position: 'relative',
    overflow: 'hidden',
}));
// source: https://stackoverflow.com/questions/27277641/create-a-checkered-background-using-css
const CheckeredBackground = (0, styles_1.styled)(layout_1.Box) `
    background: linear-gradient(
            45deg,
            rgba(0, 0, 0, 0.0980392) 25%,
            transparent 25%,
            transparent 75%,
            rgba(0, 0, 0, 0.0980392) 75%,
            rgba(0, 0, 0, 0.0980392) 0
        ),
        linear-gradient(
            45deg,
            rgba(0, 0, 0, 0.0980392) 25%,
            transparent 25%,
            transparent 75%,
            rgba(0, 0, 0, 0.0980392) 75%,
            rgba(0, 0, 0, 0.0980392) 0
        ),
        white;
    background-repeat: repeat, repeat;
    background-position: 0px 0, 5px 5px;
    transform-origin: 0 0 0;
    background-origin: padding-box, padding-box;
    background-clip: border-box, border-box;
    background-size: 10px 10px, 10px 10px;
    box-shadow: none;
    text-shadow: none;
    transform: scaleX(1) scaleY(1) scaleZ(1);
`;
const LogoPreview = (_a) => {
    var { height, logo, alt } = _a, props = __rest(_a, ["height", "logo", "alt"]);
    const theme = (0, styles_1.useTheme)();
    const [hovered, setHovered] = react_1.default.useState(false);
    return ((0, jsx_runtime_1.jsxs)(LogoBox, Object.assign({ onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), height: height }, { children: [(0, jsx_runtime_1.jsx)(CheckeredBackground, { position: "absolute", top: 0, left: 0, zIndex: -1, margin: "1px", width: "calc(100% - 2px)", height: "calc(100% - 2px)", overflow: "hidden" }), (0, jsx_runtime_1.jsx)(CornerPad, { rotation: 0, top: 0, left: 0 }), (0, jsx_runtime_1.jsx)(CornerPad, { rotation: 90, top: 0, right: 0 }), (0, jsx_runtime_1.jsx)(CornerPad, { rotation: 180, bottom: 0, right: 0 }), (0, jsx_runtime_1.jsx)(CornerPad, { rotation: 270, bottom: 0, left: 0 }), (0, jsx_runtime_1.jsx)("img", { src: logo, alt: alt, width: "100%", height: "95%", style: { objectFit: 'contain' } }), hovered && ((0, jsx_runtime_1.jsx)(layout_1.Column, Object.assign({ margin: "1px", width: "calc(100% - 2px)", height: "calc(100% - 2px)", position: "absolute", top: 0, left: 0, bg: theme.colors.hoverBlue, opacity: 0.9, justifyContent: "center", alignItems: "center" }, { children: props.children })))] })));
};
exports.LogoPreview = LogoPreview;
//# sourceMappingURL=logo_preview.js.map